import { render, staticRenderFns } from "./ProductSuggest.vue?vue&type=template&id=01e7ff68&scoped=true"
import script from "./ProductSuggest.vue?vue&type=script&lang=js"
export * from "./ProductSuggest.vue?vue&type=script&lang=js"
import style0 from "./ProductSuggest.vue?vue&type=style&index=0&id=01e7ff68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e7ff68",
  null
  
)

export default component.exports